/* Nina Amour storefront add-ons: sale price display, card colours/sizes, offers, cart free-item highlight */
(function () {
  if (window.__naCards) return;
  window.__naCards = true;

  var CFG = {
    off: 0.20,                              // storewide automatic discount ("20% OFF any item")
    dealEnd: '2026-10-31T23:59:59+04:00',   // end of "Buy 2 Get 1 FREE" (keep equal to the discount's end date)
    dealTitle: /buy\s*2\s*get\s*1/i,        // title of the Buy 2 Get 1 automatic discount
    whatsapp: '971585923288',                         // WhatsApp number, digits only with country code (e.g. 9715XXXXXXXX). Empty = no chat button
    freeShip: 500,                          // free standard delivery from this order value (AED) - keep equal to the shipping rate setting
    shipFee: 40,                            // standard delivery fee (AED)
    dealSection: 'section_rJTeU3',          // id of the homepage deal banner section (same in every language)
    motion: false,                          // master switch for the scroll/3D motion layer (false = static page)
    marquee: false,                         // moving offers strip on the homepage
    progress: false,                        // thin scroll-progress line at the top of the page
    heroSection: '__hero_jVaWmY',           // id suffix of the homepage hero section
    heroVideo: '',                          // looping video for the homepage hero. Empty = the hero shows its normal image. Stage video: https://cdn.shopify.com/videos/c/o/v/728d2d22252a4935b011c6fdad93ef37.mp4
    heroVideoMobile: '',                    // phone copy of that video: https://cdn.shopify.com/videos/c/o/v/c980685be883494a954f66187bff781d.mp4
    coupon: 'WELCOME5',                     // welcome discount code shown after a customer signs in (empty = no pop-up). Keep equal to the code in Shopify
    couponPct: 5,                           // its value, for the texts
    popupDelay: 8000,                       // ms before the sign-up pop-up shows
    creditText: 'Powered by Dodeal',        // footer credit (replaces "Powered by Shopify")
    creditUrl: 'https://dodeal.com',
    sizeSystems: ['INT', 'UK', 'EU', 'US'], // size systems the customer can switch between. The first one is how sizes are saved in Shopify. Fewer than 2 = no switch
    sizeMap: {                              // INT size: [UK, EU, US] - from the supplier's own size chart (Ohyeah, "INT. Size" table). Edit the numbers here if that chart changes
      'XS': [8, 36, 4], 'S': [10, 38, 6], 'M': [12, 40, 8], 'L': [14, 42, 10], 'XL': [16, 44, 12], '2XL': [18, 46, 14],
      '3XL': [20, 48, 16], '4XL': [22, 50, 18], '5XL': [24, 52, 20], '6XL': [26, 54, 22], '7XL': [28, 56, 24]
    },
    sizeBody: {                             // INT size: body [bust, waist, hips] in cm, same supplier chart (it has no single-size row above 5XL)
      'XS': ['81–86', '61–66', '86–91'], 'S': ['86–91', '66–71', '91–96'], 'M': ['91–97', '71–76', '96–101'], 'L': ['97–102', '76–81', '101–106'],
      'XL': ['102–107', '81–86', '106–111'], '2XL': ['107–112', '86–91', '111–116'], '3XL': ['112–117', '91–96', '116–121'],
      '4XL': ['117–122', '96–101', '121–126'], '5XL': ['122–129', '101–106', '126–131']
    },
    sizeHold: /c0458/i,                     // products whose size labels are not confirmed with the supplier yet (matched against the product link): they keep their plain sizes, no UK/EU/US
    sizeNames: {                            // how the Arabic translation spells sizes -> the saved size (so every language shows S, M, L ... the same way)
      'صغير': 'S', 'متوسط': 'M', 'كبير': 'L', 'كبير جدا': 'XL', 'إكس إل': 'XL', 'اكس ال': 'XL', 'إكس لارج': 'XL',
      'إكس لارج كبير جدا': '2XL', 'مقاسات صغيرة-متوسطة': 'XS-M'
    }
  };
  var DEAL_END = new Date(CFG.dealEnd).getTime();
  var AR = /^ar/i.test(document.documentElement.lang || (window.Shopify && Shopify.locale) || '');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var PCT = Math.round(CFG.off * 100);

  /* ---------- texts (English + Arabic) ---------- */
  var T = AR ? {
    regular: 'السعر الأصلي',
    save: 'وفّري ',
    saveNote: ' — يُخصم تلقائياً عند الدفع',
    b2g1: 'اشتري 2 والثالثة مجاناً',
    b2g1Note: ' — أضيفي أي 3 قطع والأقل سعراً تكون مجاناً. ',
    oneOffer: 'عرض واحد لكل طلب — نطبّق دائماً العرض الأوفر لكِ.',
    ends: function (l) { return 'ينتهي خلال ' + l.d + ' يوم ' + l.h + ' ساعة ' + l.m + ' دقيقة'; },
    delivery: 'توصيل خلال 24 ساعة',
    deliveryNote: ' — ' + CFG.shipFee + ' درهم، ومجاناً للطلبات فوق ' + CFG.freeShip + ' درهم. التوصيل في نفس اليوم متاح.',
    tag: 'اشتري 2 والثالثة مجاناً',
    colour: 'اللون',
    dateLocale: 'ar-AE-u-nu-latn',
    usp: function (endTxt) {
      return [
        ['-' + PCT + '%', 'خصم ' + PCT + '% على كل القطع', 'يُخصم تلقائياً عند الدفع'],
        ['🎁', 'اشتري 2 والثالثة مجاناً', 'القطعة الأقل سعراً مجاناً · حتى ' + endTxt],
        ['🚚', 'توصيل مجاني فوق ' + CFG.freeShip + ' درهم', 'خلال 24 ساعة · ومتاح في نفس اليوم'],
        ['S–5XL', 'مقاسات عادية وكبيرة', 'أغلب الموديلات متوفرة بالنوعين']
      ];
    },
    superDeal: 'عرض خاص',
    units: ['يوم', 'ساعة', 'دقيقة', 'ثانية'],
    cartFree: function (f, k) {
      var fr = function (x) { return x === 1 ? 'قطعة مجاناً' : x === 2 ? 'قطعتين مجاناً' : x + ' قطع مجاناً'; };
      var pc = k === 1 ? 'قطعة واحدة' : k === 2 ? 'قطعتين' : k + ' قطع';
      return '<b>🎉 حصلتِ على ' + fr(f) + '!</b> الأقل سعراً هدية منّا. أضيفي ' + pc + ' لتحصلي على ' + fr(f + 1) + '.';
    },
    cartAdd: function (k) { return '<b>تم تطبيق خصم ' + PCT + '%.</b> أضيفي ' + (k === 1 ? 'قطعة واحدة' : 'قطعتين') + ' — مع 3 قطع تصبح الأقل سعراً مجاناً. نطبّق دائماً العرض الأوفر لكِ.'; },
    cartPctBetter: '<b>تم تطبيق خصم ' + PCT + '%</b> — في هذه السلة هو أوفر لكِ من عرض الثالثة مجاناً.',
    cartPct: '<b>تم تطبيق خصم ' + PCT + '%.</b>',
    shipFree: '<b>🚚 حصلتِ على توصيل مجاني</b> — يصلك خلال 24 ساعة.',
    shipAdd: function (x) { return '🚚 أضيفي بقيمة <b>' + x + ' درهم</b> لتحصلي على <b>توصيل مجاني</b>.'; },
    free: 'مجاناً',
    oneFree: 'قطعة مجاناً',
    popTitle: 'خصم ' + CFG.couponPct + '% إضافي على طلبك',
    popText: 'سجّلي حسابك الآن واحصلي على كوبون خصم ' + CFG.couponPct + '% يُضاف فوق عروضنا الحالية.',
    popCta: 'سجّلي الآن واحصلي على الكوبون',
    popNo: 'لا، شكراً',
    codeTitle: 'أهلاً بكِ! هذا كوبونك',
    codeText: 'خصم ' + CFG.couponPct + '% إضافي على طلبك، يُستخدم مرة واحدة. أدخلي الكود عند الدفع أو اضغطي الزر ليُطبَّق تلقائياً.',
    codeCopy: 'نسخ الكود', codeCopied: 'تم النسخ ✓', codeUse: 'استخدميه الآن', close: 'إغلاق',
    sizeSystem: 'نظام المقاس', sizeChart: 'جدول المقاسات', sizeBody: ['الصدر', 'الخصر', 'الأرداف'],
    sizeChartNote: 'الصدر والخصر والأرداف هي قياسات الجسم بالسنتيمتر. الخامات مطاطية. محتارة بين مقاسين؟ راسلينا على واتساب لنساعدك في الاختيار.',
    waText: 'مرحباً Nina Amour، عندي استفسار.',
    waLabel: 'تواصلي معنا',
    waAria: 'تواصلي معنا على واتساب',
    colours: { black: 'أسود', white: 'أبيض', red: 'أحمر', blue: 'أزرق', 'blue green': 'أزرق مخضر', pink: 'وردي', purple: 'بنفسجي', green: 'أخضر', nude: 'بيج', burgundy: 'عنابي', gold: 'ذهبي', rose: 'وردي غامق', brown: 'بني', gray: 'رمادي', grey: 'رمادي', cyan: 'سماوي' }
  } : {
    regular: 'Regular price',
    save: 'You save ',
    saveNote: ' — applied automatically at checkout',
    b2g1: 'Buy 2 Get 1 FREE',
    b2g1Note: ' — add any 3 pieces and the lowest-priced one is free. ',
    oneOffer: 'One offer per order — we always apply the one that saves you more.',
    ends: function (l) { return 'Ends in ' + l.d + 'd ' + l.h + 'h ' + l.m + 'm'; },
    delivery: 'Delivery within 24 hours',
    deliveryNote: ' — Dhs. ' + CFG.shipFee + ', FREE on orders over Dhs. ' + CFG.freeShip + '. Same-day delivery available.',
    tag: 'Buy 2 Get 1 Free',
    colour: 'Colour',
    dateLocale: 'en-GB',
    usp: function (endTxt) {
      return [
        ['-' + PCT + '%', PCT + '% OFF everything', 'Taken off automatically at checkout'],
        ['🎁', 'Buy 2 Get 1 FREE', 'Lowest-priced piece is free · until ' + endTxt],
        ['🚚', 'Free delivery over Dhs. ' + CFG.freeShip, 'Delivered within 24 hours · same-day available'],
        ['S–5XL', 'Regular & plus sizes', 'Most styles come in both']
      ];
    },
    superDeal: 'Super Deal',
    units: ['Days', 'Hours', 'Minutes', 'Seconds'],
    cartFree: function (f, k) {
      var fr = function (x) { return x === 1 ? '1 piece FREE' : x + ' pieces FREE'; };
      return '<b>🎉 You got ' + fr(f) + '!</b> The lowest-priced ' + (f === 1 ? 'piece is' : 'pieces are') + ' on us. Add ' + k + ' more ' + (k === 1 ? 'piece' : 'pieces') + ' to get ' + fr(f + 1) + '.';
    },
    cartAdd: function (k) { return '<b>' + PCT + '% OFF applied.</b> Add ' + k + ' more ' + (k === 1 ? 'piece' : 'pieces') + ' — with 3 pieces the lowest-priced one can be FREE. We always apply the offer that saves you more.'; },
    cartPctBetter: '<b>' + PCT + '% OFF applied</b> — on this bag it saves you more than Buy 2 Get 1 FREE.',
    cartPct: '<b>' + PCT + '% OFF applied.</b>',
    shipFree: '<b>🚚 FREE delivery unlocked</b> — delivered within 24 hours.',
    shipAdd: function (x) { return '🚚 Add <b>Dhs. ' + x + '</b> more for <b>FREE delivery</b>.'; },
    free: 'FREE',
    oneFree: '1 FREE',
    popTitle: 'Extra ' + CFG.couponPct + '% OFF your order',
    popText: 'Create your account now and get a ' + CFG.couponPct + '% coupon — on top of our current offers.',
    popCta: 'Register now & get the coupon',
    popNo: 'No, thanks',
    codeTitle: 'Welcome! Here is your coupon',
    codeText: 'An extra ' + CFG.couponPct + '% off your order, valid once. Enter the code at checkout, or tap the button and it is applied automatically.',
    codeCopy: 'Copy code', codeCopied: 'Copied ✓', codeUse: 'Use it now', close: 'Close',
    sizeSystem: 'Size system', sizeChart: 'Size chart', sizeBody: ['Bust', 'Waist', 'Hips'],
    sizeChartNote: 'Bust, waist and hips are body measurements in cm. Our fabrics stretch. Between two sizes? Message us on WhatsApp and we will help you choose.',
    waText: 'Hi Nina Amour, I have a question.',
    waLabel: 'Chat with us',
    waAria: 'Chat with us on WhatsApp',
    colours: null
  };
  function colourName(c) { return (T.colours && T.colours[(c || '').toLowerCase()]) || c || ''; }
  function dealOn() { return DEAL_END - Date.now() > 0; }
  var HEX = { black: '#111111', white: '#ffffff', red: '#c1121f', blue: '#2f5fd0', 'blue green': '#2a9d8f', pink: '#f5a9c4', purple: '#7b4bb3', green: '#1f7a4d', nude: '#e2bfa3', burgundy: '#6d1a36', gold: '#d4af37', rose: '#e0527f', brown: '#7a4a2b', gray: '#8a8a8a', grey: '#8a8a8a', cyan: '#35b6c9' };
  var KEY = 'na_products_v4', TTL = 10 * 60 * 1000, data = null, timer = null, cartTimer = null;

  function fonts() {            // the Arabic fonts are imported at the top of na-custom.css (earlier, no font flash); this only warms up the connection
    if (!AR || document.querySelector('link[data-na-fonts]')) return;
    ['https://fonts.googleapis.com', 'https://fonts.gstatic.com'].forEach(function (h) {
      var pc = document.createElement('link'); pc.rel = 'preconnect'; pc.href = h; pc.crossOrigin = 'anonymous'; pc.setAttribute('data-na-fonts', '1');
      document.head.appendChild(pc);
    });
  }
  try { fonts(); } catch (e) {}

  function num(n) { return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function left() {
    var s = Math.max(0, Math.floor((DEAL_END - Date.now()) / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
  }

  /* ---------- 1. Sale price display: price is stored at full price, 20% comes off automatically ---------- */
  function salePrice(box) {
    var p = box.querySelector('.price');
    if (!p) return;
    var node = p.querySelector('bdi') || p;
    var text = node.textContent.trim();
    var was = box.querySelector('.na-was');
    if (was) {
      if (box.__naSale === text) return;          // already done
      was.remove();                               // theme re-rendered the price
    } else if (box.querySelector('.compare-at-price')) {
      box.setAttribute('data-na-sale', '1');      // product has its own sale price
      return;
    }
    var m = text.match(/[\d.,]*\d/);
    var full = m ? parseFloat(m[0].replace(/,/g, '')) : 0;
    if (!(full > 0)) { box.setAttribute('data-na-sale', '1'); return; }
    var sale = Math.round(full * (1 - CFG.off) * 100) / 100;
    var saleText = text.replace(m[0], num(sale));
    node.textContent = saleText;
    box.__naSale = saleText;
    box.__naFull = full;
    was = el('span', 'price-item__group compare-at-price na-was');
    was.appendChild(el('span', 'visually-hidden', T.regular));
    was.appendChild(el('bdi', '', text));
    p.parentNode.insertBefore(was, p.nextSibling);
    box.setAttribute('data-na-sale', '1');
  }
  function salePass() {
    var list = document.querySelectorAll('product-price, .sticky-add-to-cart__price');
    for (var i = 0; i < list.length; i++) { try { salePrice(list[i]); } catch (e) { list[i].setAttribute('data-na-sale', '1'); } }
    offerBox();
  }

  /* ---------- 2. Product page offer box ---------- */
  function offerBox() {
    var pp = document.querySelector('.product-details product-price');
    if (!pp || !pp.__naFull) return;
    var box = pp.parentNode.querySelector('.na-offer');
    var save = Math.round(pp.__naFull * CFG.off * 100) / 100;
    var cur = (pp.querySelector('.na-was bdi') || {}).textContent || '';
    var saveText = cur.replace(/[\d.,]*\d/, num(save));
    if (box && box.__naSave === saveText) return;
    if (box) box.remove();
    box = el('div', 'na-offer');
    box.__naSave = saveText;
    var r1 = el('div', 'na-offer__row');
    r1.appendChild(el('span', 'na-offer__pill', '-' + Math.round(CFG.off * 100) + '%'));
    var t1 = el('div');
    var st = el('strong', '', T.save);
    st.appendChild(el('bdi', '', saveText));
    t1.appendChild(st);
    t1.appendChild(document.createTextNode(T.saveNote));
    r1.appendChild(t1);
    box.appendChild(r1);
    if (dealOn()) {
      var r2 = el('div', 'na-offer__row');
      r2.appendChild(el('span', 'na-offer__gift', '🎁'));
      var t2 = el('div');
      t2.appendChild(el('strong', '', T.b2g1));
      t2.appendChild(document.createTextNode(T.b2g1Note));
      var ends = el('span', 'na-offer__ends');
      t2.appendChild(ends);
      r2.appendChild(t2);
      box.appendChild(r2);
      box.appendChild(el('div', 'na-offer__note', T.oneOffer));
      var setEnds = function () {
        var l = left();
        var txt = T.ends(l);
        if (ends.textContent !== txt) ends.textContent = txt;
      };
      setEnds();
      var iv = setInterval(function () { if (!ends.isConnected) { clearInterval(iv); return; } setEnds(); }, 30000);
    }
    if (CFG.freeShip) {
      var r3 = el('div', 'na-offer__row');
      r3.appendChild(el('span', 'na-offer__gift', '🚚'));
      var t3 = el('div');
      t3.appendChild(el('strong', '', T.delivery));
      t3.appendChild(document.createTextNode(T.deliveryNote));
      r3.appendChild(t3);
      var noteEl = box.querySelector('.na-offer__note');
      if (noteEl) box.insertBefore(r3, noteEl); else box.appendChild(r3);
    }
    pp.parentNode.insertBefore(box, pp.nextSibling);
  }

  /* ---------- 3. Product cards: badge, colours, sizes ---------- */
  function load() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < TTL) return Promise.resolve(c.d);
    } catch (e) {}
    return fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (j) {
      var d = {};
      (j.products || []).forEach(function (p) {
        var sizes = [], color = '', style = '';
        var hasSize = p.options && p.options[0] && /size/i.test(p.options[0].name);
        if (hasSize) sizes = (p.options[0].values || []).slice();
        (p.tags || []).forEach(function (t) {
          if (t.indexOf('color:') === 0) color = t.slice(6);
          if (t.indexOf('style:') === 0) style = t.slice(6);
        });
        d[p.handle] = { s: sizes, c: color, g: style, i: p.images && p.images[0] ? p.images[0].src : '' };
      });
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    });
  }

  function badges() {
    var cards = document.querySelectorAll('product-card:not([data-na-badge])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-na-badge', '1');
      var g = card.querySelector('.card-gallery');
      if (!g) return;
      var old = card.querySelector('.product-badges');
      if (old) old.style.display = 'none';
      g.appendChild(el('span', 'na-badge', '-' + PCT + '%'));
      if (dealOn()) g.appendChild(el('span', 'na-tag', T.tag));
    });
  }

  function decorate() {
    badges();
    if (revealMark) { try { revealMark(); } catch (e) {} }
    if (!data) return;
    var groups = {};
    Object.keys(data).forEach(function (h) { var g = data[h].g; if (g) (groups[g] = groups[g] || []).push(h); });
    var cards = document.querySelectorAll('product-card:not([data-na])');
    Array.prototype.forEach.call(cards, function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var h = decodeURIComponent(m[1]), p = data[h];
      card.setAttribute('data-na', '1');
      if (!p) return;
      var host = card.querySelector('.product-card__content') || card;
      var box = el('div', 'na-card-meta');
      var sib = p.g && groups[p.g] && groups[p.g].length > 1 ? groups[p.g] : null;
      if (sib) {
        var cw = el('div', 'na-colors');
        var img = card.querySelector('img');
        var orig = img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') } : null;
        sib.forEach(function (sh) {
          var sp = data[sh], d = el('a', 'na-dot' + (sh === h ? ' is-current' : ''));
          d.href = ROOT + 'products/' + sh;
          d.title = colourName(sp.c);
          d.setAttribute('aria-label', colourName(sp.c) || T.colour);
          d.style.background = HEX[(sp.c || '').toLowerCase()] || '#cccccc';
          if (img && sh !== h && sp.i) {
            d.addEventListener('mouseenter', function () { img.removeAttribute('srcset'); img.src = sp.i + (sp.i.indexOf('?') < 0 ? '?' : '&') + 'width=720'; });
            d.addEventListener('mouseleave', function () { if (orig.srcset) img.setAttribute('srcset', orig.srcset); img.src = orig.src; });
          }
          cw.appendChild(d);
        });
        box.appendChild(cw);
      }
      if (p.s.length) {
        var sw = el('div', 'na-sizes'), max = 7;
        p.s.slice(0, max).forEach(function (s) { var c = el('span', 'na-size', s); if (!held(h)) c.setAttribute('data-s', s); sw.appendChild(c); });
        if (held(h)) sw.setAttribute('data-hold', '1');
        if (p.s.length > max) sw.appendChild(el('span', 'na-size', '+' + (p.s.length - max)));
        box.appendChild(sw);
      }
      if (box.childNodes.length) host.appendChild(box);
    });
    sizeCards();
  }

  /* ---------- 4. Home page: offer strip + deal banner countdown ---------- */
  function isHome() { return /^\/([a-z]{2}(-[a-z]{2})?\/?)?$/i.test(location.pathname); }

  function strip() {
    if (!isHome() || document.querySelector('.na-usp')) return;
    var first = document.querySelector('main .shopify-section');
    if (!first) return;
    var end = new Date(DEAL_END);
    var endTxt;
    try { endTxt = end.toLocaleDateString(T.dateLocale, { day: 'numeric', month: 'long', timeZone: 'Asia/Dubai' }); }
    catch (e) { endTxt = end.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', timeZone: 'Asia/Dubai' }); }
    var items = T.usp(endTxt);
    var wrap = el('div', 'na-usp');
    items.forEach(function (it, i) {
      if (i === 1 && !dealOn()) return;
      var c = el('a', 'na-usp__item');
      c.href = ROOT + 'collections/all';
      c.appendChild(el('span', 'na-usp__icon', it[0]));
      var t = el('span', 'na-usp__text');
      t.appendChild(el('strong', '', it[1]));
      t.appendChild(el('small', '', it[2]));
      c.appendChild(t);
      wrap.appendChild(c);
    });
    first.parentNode.insertBefore(wrap, first.nextSibling);
  }

  function deal() {
    var secs = document.querySelectorAll('main .shopify-section');
    var sec = null;
    Array.prototype.forEach.call(secs, function (s) {
      if (sec || s.getAttribute('data-na-deal')) return;
      if (!s.querySelector('.section-background') || s.querySelector('form, product-card, cart-items-component')) return;
      var hit = !!(CFG.dealSection && s.id && s.id.indexOf(CFG.dealSection) > -1);
      if (!hit) Array.prototype.forEach.call(s.querySelectorAll('.text-block'), function (t) { if (/^\s*buy\s*2\s*get\s*1\s*free\s*$/i.test(t.textContent)) hit = true; });
      if (hit) sec = s;
    });
    if (!sec) return;
    sec.setAttribute('data-na-deal', '1');
    sec.classList.add('na-deal');
    var wrap = sec.querySelector('.section-content-wrapper');
    if (!wrap) return;
    var eb = el('div', 'na-deal__eyebrow', T.superDeal);
    wrap.insertBefore(eb, wrap.firstChild);
    if (!dealOn()) return;
    var t = el('div', 'na-deal__timer');
    t.setAttribute('role', 'timer');
    var parts = {};
    [['d', T.units[0]], ['h', T.units[1]], ['m', T.units[2]], ['s', T.units[3]]].forEach(function (u) {
      var box = el('div', 'na-deal__unit');
      var n = el('span', 'na-deal__num', '0');
      box.appendChild(n); box.appendChild(el('span', 'na-deal__lbl', u[1]));
      t.appendChild(box); parts[u[0]] = n;
    });
    wrap.insertBefore(t, eb.nextSibling);
    function tick() {
      if (!dealOn()) { t.remove(); clearInterval(iv); return; }
      var l = left();
      ['d', 'h', 'm', 's'].forEach(function (k) { var v = String(l[k]); if (parts[k].textContent !== v) parts[k].textContent = v; });
    }
    var iv = setInterval(tick, 1000); tick();
  }

  /* ---------- 5. Cart: highlight the free piece + offer note ---------- */
  function renderCart(cart) {
    var comps = document.querySelectorAll('cart-items-component');
    var free = {}, b2g1 = false, pct = false, freeN = 0;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (!(a.amount > 0)) return;
        if (CFG.dealTitle.test((a.discount_application || {}).title || '')) { b2g1 = true; freeN += Math.max(1, Math.round(a.amount / (it.original_price || a.amount))); free[it.key] = it.final_line_price === 0 ? T.free : T.oneFree; }
        else pct = true;
      });
    });
    var n = cart.item_count || 0, msg = '';
    if (b2g1) msg = T.cartFree(freeN, 3 - (n % 3));
    else if (pct && dealOn() && n < 3) msg = T.cartAdd(3 - n);
    else if (pct && dealOn()) msg = T.cartPctBetter;
    else if (pct) msg = T.cartPct;
    var total = (cart.total_price || 0) / 100, ship = '';
    if (CFG.freeShip && n) {
      var pctDone = Math.max(4, Math.min(100, Math.round(total / CFG.freeShip * 100)));
      ship = total >= CFG.freeShip
        ? T.shipFree
        : T.shipAdd(num(CFG.freeShip - total));
      ship = '<div class="na-cart-ship">' + ship + '<div class="na-bar"><i style="width:' + pctDone + '%"></i></div></div>';
    }
    var html = (msg ? '<div>' + msg + '</div>' : '') + ship;
    Array.prototype.forEach.call(comps, function (comp) {
      Array.prototype.forEach.call(comp.querySelectorAll('tr.cart-items__table-row[data-key]'), function (row) {
        var f = free[row.getAttribute('data-key')];
        Array.prototype.forEach.call(row.querySelectorAll('.cart-items__details li'), function (li) { if (CFG.dealTitle.test(li.textContent)) li.style.display = f ? '' : 'none'; });
        row.classList.toggle('na-free', !!f);
        var pill = row.querySelector('.na-free-pill');
        if (!f) { if (pill) pill.remove(); return; }
        var label = '🎁 ' + f;
        if (pill) { if (pill.textContent !== label) pill.textContent = label; return; }
        var host = row.querySelector('.cart-items__title-row') || row.querySelector('.cart-items__details');
        if (host) host.appendChild(el('span', 'na-free-pill', label));
      });
      var note = comp.querySelector('.na-cart-note');
      if (!html || !n) { if (note) note.remove(); return; }
      if (!note) {
        var anchor = comp.querySelector('.cart-items');
        if (!anchor) return;
        note = el('div', 'na-cart-note');
        anchor.parentNode.insertBefore(note, anchor);
      }
      note.classList.toggle('is-free', b2g1);
      if (note.__naMsg !== html) { note.innerHTML = html; note.__naMsg = html; }
    });
    sizeCart();
  }
  function cartUI() {
    if (!document.querySelector('cart-items-component')) return;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* ---------- 6. WhatsApp chat button (only when a number is set) ---------- */
  function whatsapp() {
    if (!CFG.whatsapp || document.querySelector('.na-wa')) return;
    var a = el('a', 'na-wa');
    a.href = 'https://wa.me/' + CFG.whatsapp + '?text=' + encodeURIComponent(T.waText);
    a.target = '_blank'; a.rel = 'noopener';
    a.setAttribute('aria-label', T.waAria);
    a.innerHTML = '<svg viewBox="0 0 32 32" width="24" height="24" aria-hidden="true"><path fill="currentColor" d="M4 15a12 11 0 1 1 5.200 9.100L4 27l1.700-5.600A10.800 10.800 0 0 1 4 15z"/></svg>';
    a.appendChild(el('span', '', T.waLabel));
    document.body.appendChild(a);
  }

  /* ---------- 7. Motion & 3D: sliced parallax hero, scroll reveals, card tilt, marquee, progress bar ---------- */
  var REDUCED = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FINE = !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
  var scrollFns = [], ticking = false, revealMark = null;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      for (var i = 0; i < scrollFns.length; i++) { try { scrollFns[i](); } catch (e) {} }
    });
  }

  function hero3d() {
    if (REDUCED || !isHome()) return;
    var wrap = document.querySelector('main .hero .hero__media-wrapper');
    var img = wrap && wrap.querySelector('img.hero__media');
    if (!img || wrap.querySelector('.na-hero3d')) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    var hero = wrap.closest('.hero');
    var N = window.innerWidth < 750 ? 3 : 5;
    var speeds = [0.10, 0.26, 0.16, 0.30, 0.12];
    var box = el('div', 'na-hero3d'), inners = [], pending = N;
    function ready() {
      if (--pending > 0) return;
      hero.classList.add('na-hero-ready');
      requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-in'); }); });
      setTimeout(function () { live = true; box.classList.add('is-live'); update(); }, 2300);
    }
    for (var i = 0; i < N; i++) {
      var sl = el('div', 'na-hero3d__slice');
      sl.style.left = (100 / N * i) + '%';
      sl.style.width = (100 / N + 0.06) + '%';
      var inner = el('div', 'na-hero3d__inner');
      inner.style.transitionDelay = (i * 110) + 'ms';
      var im = new Image();
      im.alt = '';
      im.style.width = (N * 100) + '%';
      im.style.left = (-i * 100) + '%';
      im.onload = ready; im.onerror = ready;
      im.src = src;
      inner.appendChild(im);
      sl.appendChild(inner);
      box.appendChild(sl);
      inners.push(inner);
    }
    wrap.appendChild(box);
    var mid = (N - 1) / 2, mx = 0, my = 0, live = false;
    function update() {
      if (!live) return;
      var r = hero.getBoundingClientRect();
      var h = r.height || 1;
      var gone = Math.max(0, -r.top);                 // how much of the hero has scrolled past the top
      if (gone > h) return;
      var p = gone / h;
      for (var i = 0; i < N; i++) {
        var ty = gone * speeds[i % speeds.length];
        var ry = (i - mid) * (p * -6) + mx * 4;
        var rx = my * -3;
        inners[i].style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(' + (1.06 + p * 0.06).toFixed(3) + ')';
      }
    }
    scrollFns.push(update);
    if (FINE) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - 0.5; my = (e.clientY - r.top) / r.height - 0.5;
        onScroll();
      });
      hero.addEventListener('pointerleave', function () { mx = 0; my = 0; onScroll(); });
    }
    var hp = hero.querySelector('.hero__content-wrapper .text-block p');
    if (hp && !hp.children.length) {
      var words = hp.textContent.trim().split(/\s+/);
      hp.textContent = '';
      words.forEach(function (w, i) {
        var o = el('span', 'na-w'), inn = el('span', '', w);
        inn.style.animationDelay = (250 + i * 90) + 'ms';
        o.appendChild(inn);
        hp.appendChild(o);
        hp.appendChild(document.createTextNode(' '));
      });
    }
  }

  function reveals() {
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target;
        io.unobserve(t);
        t.classList.add('is-in');
        setTimeout(function () { t.classList.remove('na-reveal', 'na-reveal--flip', 'is-in'); t.style.transitionDelay = ''; }, 1700);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    function mark(list, stagger, extra) {
      var vh = window.innerHeight, rowTop = null, k = 0;
      Array.prototype.forEach.call(list, function (n) {
        if (n.__naRev) return;
        n.__naRev = 1;
        var r = n.getBoundingClientRect();
        if (r.top < vh * 0.95 || !r.height) return;      // already on screen (or hidden): leave it alone
        if (rowTop === null || Math.abs(r.top - rowTop) > 24) { rowTop = r.top; k = 0; }
        n.style.transitionDelay = (k++ * stagger) + 'ms';
        n.classList.add('na-reveal');
        if (extra) n.classList.add(extra);
        io.observe(n);
      });
    }
    revealMark = function () {
      mark(document.querySelectorAll('main product-card'), 70);
      mark(document.querySelectorAll('main .collection-card'), 90, 'na-reveal--flip');
      mark(document.querySelectorAll('main .na-usp__item, main .image-block, main .na-marquee, main .na-deal .section-content-wrapper'), 90);
    };
    revealMark();
    // safety net: never leave something hidden if the observer missed it
    var last = 0;
    scrollFns.push(function () {
      var now = Date.now();
      if (now - last < 250) return;
      last = now;
      var left = document.querySelectorAll('.na-reveal:not(.is-in)'), vh = window.innerHeight;
      for (var i = 0; i < left.length; i++) {
        var r = left[i].getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) (function (t) {
          io.unobserve(t);
          t.classList.add('is-in');
          setTimeout(function () { t.classList.remove('na-reveal', 'na-reveal--flip', 'is-in'); t.style.transitionDelay = ''; }, 1700);
        })(left[i]);
      }
    });
  }

  function tilt() {
    if (REDUCED || !FINE) return;
    var cur = null, raf = 0, ev = null;
    function reset(g) { g.style.transform = ''; g.classList.remove('na-tilting'); }
    document.addEventListener('pointermove', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('product-card .card-gallery, .collection-card__inner') : null;
      if (cur && cur !== t) { reset(cur); cur = null; }
      if (!t) return;
      cur = t; ev = e;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (!cur) return;
        if (!cur.querySelector(':scope > .na-glare')) cur.appendChild(el('i', 'na-glare'));
        var r = cur.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        cur.classList.add('na-tilting');
        cur.style.transform = 'perspective(800px) rotateX(' + (-y * 7).toFixed(2) + 'deg) rotateY(' + (x * 9).toFixed(2) + 'deg) scale(1.03)';
        cur.style.setProperty('--na-gx', ((x + 0.5) * 100).toFixed(1) + '%');
        cur.style.setProperty('--na-gy', ((y + 0.5) * 100).toFixed(1) + '%');
      });
    }, { passive: true });
    document.documentElement.addEventListener('pointerleave', function () { if (cur) { reset(cur); cur = null; } });
  }

  function marquee() {
    if (!CFG.marquee || !isHome() || document.querySelector('.na-marquee')) return;
    var secs = document.querySelectorAll('main .shopify-section');
    var after = secs[1];
    if (!after) return;
    var parts = [Math.round(CFG.off * 100) + '% OFF everything'];
    if (dealOn()) parts.push('Buy 2 Get 1 FREE');
    if (CFG.freeShip) { parts.push('Free delivery over Dhs. ' + CFG.freeShip); parts.push('Delivered within 24 hours'); }
    var m = el('div', 'na-marquee');
    m.setAttribute('aria-hidden', 'true');
    var shift = el('div', 'na-marquee__shift'), track = el('div', 'na-marquee__track');
    for (var r = 0; r < 4; r++) parts.forEach(function (t) { track.appendChild(el('span', 'na-marquee__item', t)); track.appendChild(el('span', 'na-marquee__sep', '✦')); });
    shift.appendChild(track);
    m.appendChild(shift);
    after.parentNode.insertBefore(m, after.nextSibling);
    if (!REDUCED) scrollFns.push(function () { shift.style.transform = 'translate3d(' + (-(window.scrollY * 0.35) % 600).toFixed(1) + 'px,0,0)'; });
  }

  function progress() {
    if (!CFG.progress || REDUCED || document.querySelector('.na-progress')) return;
    var bar = el('div', 'na-progress');
    document.body.appendChild(bar);
    scrollFns.push(function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, window.scrollY / max) : 0).toFixed(4) + ')';
    });
  }

  function dealParallax() {
    if (REDUCED) return;
    scrollFns.push(function () {
      var sec = document.querySelector('.na-deal');
      var bg = sec && sec.querySelector('.section-background');
      if (!bg || window.innerWidth < 750) return;
      var r = sec.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var slack = r.width * 900 / 2400 - r.height;         // banner image is 2400x900, shown with background-size: cover
      if (slack < 80) return;
      var d = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;   // -0.5 .. 0.5 while on screen
      bg.style.backgroundPosition = 'center calc(50% + ' + (Math.max(-1, Math.min(1, d * 1.6)) * slack * 0.45).toFixed(1) + 'px)';
    });
  }

  function motion() {
    if (!CFG.motion) return;
    try { hero3d(); } catch (e) {}
    try { marquee(); } catch (e) {}
    try { reveals(); } catch (e) {}
    try { tilt(); } catch (e) {}
    try { progress(); } catch (e) {}
    try { dealParallax(); } catch (e) {}
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- phones: lazy card images ask for the size they are actually shown at (the theme asks for full-width ones) ---------- */
  function slimImages() {
    if (!window.matchMedia || !window.matchMedia('(max-width:749px)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('img[loading="lazy"][srcset]'), function (img) {
      if (img.__naS || img.currentSrc) return;               // already loading or loaded: leave it
      var cls = String(img.className || '');
      if (/resource-card__image/.test(cls)) { img.sizes = '31vw'; img.__naS = 1; }
      else if (/product-media__image/.test(cls) && /,\s*100vw\s*$/.test(img.sizes || '') && img.closest('.shopify-section[id*="product_list"]')) { img.sizes = '45vw'; img.__naS = 1; }
    });
  }

  /* ---------- home hero video (the still frame stays if the video cannot play) ---------- */
  function heroVideo() {
    if (!CFG.heroVideo || !window.matchMedia) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (navigator.connection && navigator.connection.saveData) return;
    var w = document.querySelector('.shopify-section[id$="' + CFG.heroSection + '"] .hero__media-wrapper');
    if (!w || w.querySelector('.na-hero-video')) return;
    if (!heroVideo.ready) {                                  // wait for the page's own files first; the still frame shows meanwhile
      heroVideo.ready = true;
      if (document.readyState === 'complete') setTimeout(heroVideo, 150);
      else window.addEventListener('load', function () { setTimeout(heroVideo, 150); });
      return;
    }
    var phone = window.matchMedia('(max-width:749px)').matches;
    var v = document.createElement('video');
    v.className = 'na-hero-video';
    v.muted = true; v.defaultMuted = true; v.loop = true; v.autoplay = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.tabIndex = -1; v.preload = 'auto'; v.disablePictureInPicture = true;
    v.addEventListener('playing', function () { v.classList.add('is-on'); });
    v.src = (phone && CFG.heroVideoMobile) || CFG.heroVideo;
    w.appendChild(v);
    function go() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    go();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) go(); });   // page opened in a background tab
    window.addEventListener('pageshow', go);
    if ('IntersectionObserver' in window) {                  // do not keep decoding once the hero is scrolled away
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) go(); else v.pause(); }, { threshold: 0.05 }).observe(w);
    }
  }

  /* ---------- footer credit ---------- */
  function credit() {
    if (!CFG.creditText) return;
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-footer-group a[href*="shopify.com"]'), function (a) {
      a.textContent = CFG.creditText;
      a.href = CFG.creditUrl || '#';
      a.target = '_blank'; a.rel = 'noopener';
      a.classList.add('na-credit');
    });
  }

  /* ---------- welcome coupon: pop-up asks visitors to register, signed-in customers get the code ---------- */
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }
  function visit(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function signedIn() {
    try {
      if (window.__st && window.__st.cid) return true;
      var m = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page;
      if (m && m.customerId) return true;
    } catch (e) {}
    return false;
  }
  function modal(kind, build) {
    if (document.querySelector('.na-pop')) return null;
    var wrap = el('div', 'na-pop na-pop--' + kind), card = el('div', 'na-pop__card');
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true');
    var x = el('button', 'na-pop__x', '×'); x.type = 'button'; x.setAttribute('aria-label', T.close);
    card.appendChild(x);
    function close() { wrap.classList.remove('is-open'); document.removeEventListener('keydown', esc); setTimeout(function () { wrap.remove(); }, 250); }
    function esc(e) { if (e.key === 'Escape') close(); }
    build(card, close);
    wrap.appendChild(card);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    x.addEventListener('click', close);
    document.addEventListener('keydown', esc);
    document.body.appendChild(wrap);
    setTimeout(function () { wrap.classList.add('is-open'); }, 30);   // not requestAnimationFrame: it never fires while the tab is in the background
    return wrap;
  }
  function couponPopup() {
    if (!CFG.coupon) return;
    var path = location.pathname;
    if (/\/(cart|checkouts?|account|policies)(\/|$)/.test(path)) return;
    if (signedIn()) {
      if (store('na_c5') === 'shown') return;
      setTimeout(function () {
        var m = modal('code', function (card, close) {
          card.appendChild(el('div', 'na-pop__pct', CFG.couponPct + '%'));
          card.appendChild(el('h2', 'na-pop__title', T.codeTitle));
          var code = el('button', 'na-pop__code', CFG.coupon); code.type = 'button'; code.setAttribute('aria-label', T.codeCopy);
          card.appendChild(code);
          card.appendChild(el('p', 'na-pop__text', T.codeText));
          var use = el('a', 'na-pop__cta', T.codeUse);
          use.href = '/discount/' + encodeURIComponent(CFG.coupon) + '?redirect=' + encodeURIComponent(ROOT + 'collections/all');
          card.appendChild(use);
          var copy = el('button', 'na-pop__no', T.codeCopy); copy.type = 'button';
          card.appendChild(copy);
          function doCopy() {
            var done = function () { copy.textContent = T.codeCopied; };
            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CFG.coupon).then(done, done); else done();
          }
          code.addEventListener('click', doCopy); copy.addEventListener('click', doCopy);
        });
        if (m) store('na_c5', 'shown');
      }, 1200);
      return;
    }
    if (visit('na_pop')) return;                                // already shown during this visit; it shows again on the next visit
    setTimeout(function () {
      if (signedIn() || document.querySelector('.na-pop')) return;
      var m = modal('ask', function (card, close) {
        card.appendChild(el('div', 'na-pop__pct', CFG.couponPct + '%'));
        card.appendChild(el('h2', 'na-pop__title', T.popTitle));
        card.appendChild(el('p', 'na-pop__text', T.popText));
        var go = el('a', 'na-pop__cta', T.popCta);
        var back = encodeURIComponent(location.pathname);
        go.href = ROOT + 'account/login?return_to=' + back + '&return_url=' + back;
        card.appendChild(go);
        var no = el('button', 'na-pop__no', T.popNo); no.type = 'button';
        no.addEventListener('click', close);
        card.appendChild(no);
      });
      if (m) visit('na_pop', '1');
    }, CFG.popupDelay);
  }

  /* ---------- sizes: the customer picks the size system (INT / UK / EU / US); the choice is remembered ---------- */
  var SYS = CFG.sizeSystems || [], sys = SYS[0];
  function canon(v) {                       // the label the theme shows -> the size as saved in Shopify: '٢XL/٣XL' -> '2XL/3XL', 'صغير/متوسط' -> 'S/M'. null = not a size we know
    var s = String(v == null ? '' : v).replace(/[٠-٩]/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'.indexOf(d); }).replace(/[ً-ْ]/g, '').replace(/\s+/g, ' ').trim();
    var N = CFG.sizeNames || {};
    if (N[s]) return N[s];
    var sep = s.indexOf('/') >= 0 ? '/' : /[-–]/.test(s) ? '-' : '';
    var parts = sep ? s.split(/\s*[\/\-–]\s*/) : [s], out = [];
    for (var k = 0; k < parts.length; k++) {
      var p = parts[k].trim(), m = p.match(/^(\d)\s*(إكس|اكس)\s*(إل|ال)$/);
      p = N[p] || (m ? m[1] + 'XL' : p.toUpperCase().replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL'));
      if (!CFG.sizeMap[p]) return null;
      out.push(p);
    }
    return out.join(sep);
  }
  function conv(v, to) {                    // conv('S/M', 'UK') -> '8–10'; in the first system it gives the saved size itself. Unknown values come back unchanged
    var c = canon(v), i = SYS.indexOf(to);
    if (!c) return v;
    if (i < 1) return c;
    return c.split(/[\/\-–]/).map(function (p) { return CFG.sizeMap[p][i - 1]; }).join('–');
  }
  function held(h) { return !!(h && CFG.sizeHold && CFG.sizeHold.test(h)); }
  function pickerHandle(fs) {               // the product a size picker belongs to: the quick-add window's product link, else the product page itself
    var box = fs.closest('dialog, .quick-add-modal, quick-add-dialog'), m;
    if (box) { var a = box.querySelector('a[href*="/products/"]'); m = a && (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/); }
    else m = location.pathname.match(/\/products\/([^?#\/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function pickerSizes(h, n) {              // the saved sizes of that product (from the product list), when they can be matched one-to-one
    var p = data && h && data[h];
    return p && p.s && p.s.length === n ? p.s : null;
  }
  function sizeLabel(v, to) { var c = conv(v, to); return to === SYS[0] ? c : to + ' ' + c; }
  function sizePickers() {
    if (SYS.length < 2) return;
    Array.prototype.forEach.call(document.querySelectorAll('variant-picker fieldset'), function (fs) {
      var ins = fs.querySelectorAll('input[type="radio"]'), ok = false, cur = null, i, len = 2, h = pickerHandle(fs);
      var known = pickerSizes(h, ins.length), val = function (j) { return known ? known[j] : ins[j].value; };
      for (i = 0; i < ins.length; i++) { if (conv(val(i), SYS[1]) !== val(i)) ok = true; if (ins[i].checked) cur = val(i); }
      if (!ok) return;
      if (held(h)) {                                                            // sizes not confirmed yet: plain S / M / L labels only, no other systems
        for (i = 0; i < ins.length; i++) {
          var hl = ins[i].closest('label'), hs = hl && hl.querySelector('.variant-option__button-label__text'), ht = conv(val(i), SYS[0]);
          if (hs && canon(val(i)) && hs.textContent !== ht) hs.textContent = ht;
          if (hs) len = Math.max(len, hs.textContent.trim().length);
        }
        var hch = (len * 0.65).toFixed(2) + 'em';
        if (fs.style.getPropertyValue('--variant-ch') !== hch) fs.style.setProperty('--variant-ch', hch);
        return;
      }
      if (!fs.classList.contains('na-szfs')) fs.classList.add('na-szfs');
      var bar = fs.querySelector('.na-sz');
      if (!bar) {
        bar = el('div', 'na-sz');
        bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', T.sizeSystem);
        SYS.forEach(function (x) { var b = el('button', 'na-sz__b', x); b.type = 'button'; b.setAttribute('data-sys', x); bar.appendChild(b); });
        var lg = fs.querySelector('legend');
        fs.insertBefore(bar, lg ? lg.nextSibling : fs.firstChild);
      }
      Array.prototype.forEach.call(bar.children, function (b) {
        var on = b.getAttribute('data-sys') === sys;
        if (b.classList.contains('is-on') !== on) { b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      });
      for (i = 0; i < ins.length; i++) {
        var lab = ins[i].closest('label'), sp = lab && lab.querySelector('.variant-option__button-label__text'), t = conv(val(i), sys);
        if (canon(val(i)) && sp && sp.textContent !== t) sp.textContent = t;     // a value we cannot read (e.g. "One Size") keeps the theme's own label
        if (sp) len = Math.max(len, sp.textContent.trim().length);
      }
      var ch = (len * 0.65).toFixed(2) + 'em';                                  // the theme sizes the buttons for its own (often much longer) labels
      if (fs.style.getPropertyValue('--variant-ch') !== ch) fs.style.setProperty('--variant-ch', ch);
      var note = fs.querySelector('.na-sznote'), txt = '';
      if (cur != null && conv(cur, SYS[1]) !== cur) {
        txt = sizeLabel(cur, sys) + ' = ' + SYS.filter(function (x) { return x !== sys; }).map(function (x) { return sizeLabel(cur, x); }).join(' · ');
      }
      if (!note) {
        note = el('div', 'na-sznote');
        note.appendChild(el('span', 'na-sznote__eq'));
        var link = el('button', 'na-sznote__chart', T.sizeChart); link.type = 'button';
        note.appendChild(link);
        fs.appendChild(note);
      }
      if (note.firstChild.textContent !== txt) note.firstChild.textContent = txt;
    });
  }
  function sizeCards() {
    if (SYS.length < 2) return;
    Array.prototype.forEach.call(document.querySelectorAll('.na-sizes'), function (sw) {
      if (sw.hasAttribute('data-hold')) return;
      var tag = sw.querySelector('.na-size--sys');
      sw.classList.toggle('is-sys', sys !== SYS[0]);
      if (sys === SYS[0]) { if (tag) tag.remove(); }
      else {
        if (!tag) { tag = el('span', 'na-size na-size--sys'); sw.insertBefore(tag, sw.firstChild); }
        if (tag.textContent !== sys) tag.textContent = sys;
      }
      Array.prototype.forEach.call(sw.querySelectorAll('.na-size[data-s]'), function (c) {
        var t = conv(c.getAttribute('data-s'), sys);
        if (c.textContent !== t) c.textContent = t;
      });
    });
  }
  function sizeCart() {                     // cart lines keep the saved size and add the chosen system next to it: "S · UK 8"
    if (SYS.length < 2) return;
    Array.prototype.forEach.call(document.querySelectorAll('.cart-items__variant dd'), function (dd) {
      var raw = dd.textContent.split(' · ')[0].trim(), base = conv(raw, SYS[0]), c = conv(raw, sys);
      if (conv(raw, SYS[1]) === raw) return;                                    // not a size we can read
      var row = dd.closest('tr, li, .cart-items__table-row'), link = row && row.querySelector('a[href*="/products/"]');
      var t = sys !== SYS[0] && !(link && held(link.getAttribute('href'))) ? base + ' · ' + sys + ' ' + c : base;
      if (dd.textContent.trim() !== t) dd.textContent = t;
    });
  }
  function sizeChart() {
    modal('sizes', function (card) {
      card.appendChild(el('h2', 'na-pop__title', T.sizeChart));
      var tb = el('table', 'na-sztable'), hr = el('tr'), B = CFG.sizeBody || {};
      SYS.forEach(function (x) { hr.appendChild(el('th', x === sys ? 'is-on' : '', x)); });
      T.sizeBody.forEach(function (x) { hr.appendChild(el('th', 'is-body', x)); });
      tb.appendChild(hr);
      Object.keys(CFG.sizeMap).forEach(function (k) {
        var tr = el('tr');
        SYS.forEach(function (x, i) { tr.appendChild(el('td', x === sys ? 'is-on' : '', i ? String(CFG.sizeMap[k][i - 1]) : k)); });
        T.sizeBody.forEach(function (x, i) { tr.appendChild(el('td', 'is-body', B[k] ? B[k][i] : '—')); });
        tb.appendChild(tr);
      });
      card.appendChild(tb);
      card.appendChild(el('p', 'na-pop__text na-sztable__note', T.sizeChartNote));
    });
  }
  function sizes() {
    if (SYS.length < 2) return;
    var saved = store('na_sz');
    if (saved && SYS.indexOf(saved) >= 0) sys = saved;
    sizePickers();
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var b = t.closest('.na-sz__b');
      if (b) {
        e.preventDefault();
        sys = b.getAttribute('data-sys'); store('na_sz', sys);
        sizePickers(); sizeCards(); sizeCart();
        return;
      }
      if (t.closest('.na-sznote__chart')) { e.preventDefault(); sizeChart(); }
    });
    document.addEventListener('change', function (e) { if (inside(e.target, 'variant-picker')) sizePickers(); });
  }

  /* ---------- wiring ---------- */
  function schedule() { clearTimeout(timer); timer = setTimeout(decorate, 150); }
  function scheduleCart() { clearTimeout(cartTimer); cartTimer = setTimeout(cartUI, 350); }
  function inside(node, sel) { var e = node && node.nodeType === 1 ? node : node && node.parentElement; return !!(e && e.closest && e.closest(sel)); }

  function start() {
    try { salePass(); } catch (e) {}
    try { badges(); } catch (e) {}
    try { deal(); } catch (e) {}
    try { strip(); } catch (e) {}
    try { whatsapp(); } catch (e) {}
    try { motion(); } catch (e) {}
    try { slimImages(); } catch (e) {}
    try { heroVideo(); } catch (e) {}
    try { credit(); } catch (e) {}
    try { couponPopup(); } catch (e) {}
    try { sizes(); } catch (e) {}
    cartUI();
    new MutationObserver(function (muts) {
      var any = false, cart = false;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (inside(t, '.na-deal__timer, .na-offer, .na-cart-note, .na-card-meta, .na-hero3d, .na-marquee, .na-progress, .na-hero-video, .na-pop, .na-sz, .na-sznote') || (t.classList && t.classList.contains('card-gallery') && muts[i].addedNodes.length === 1 && muts[i].addedNodes[0].className === 'na-glare')) continue;
        any = true;
        if (inside(t, 'cart-items-component, cart-drawer-component')) cart = true;
      }
      if (!any) return;
      try { sizePickers(); sizeCart(); } catch (e) {}   // straight away (before the next paint), so the theme never shows the old labels after it redraws
      try { salePass(); } catch (e) {}
      schedule();
      if (cart) scheduleCart();
    }).observe(document.body, { childList: true, subtree: true });
    load().then(function (d) { data = d; decorate(); try { sizePickers(); } catch (e) {} }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
